import { Navigate, useLocation, useParams } from 'react-router-dom';

/** /admin/users → /admin/user (the plural is what people type). */
export function RedirectAdminUsers() {
  const { search } = useLocation();
  return <Navigate to={`/admin/user${search}`} replace />;
}

export function RedirectAdminUsersProfile() {
  const { userId } = useParams<{ userId: string }>();
  return <Navigate to={`/admin/user/${userId}`} replace />;
}
